import ArgosDialog from "../../../../components/Dialogs/ArgosDialog";
import ArgosFlexbox from "../../../../components/Containers/ArgosFlexbox";
import ArgosButton, {ArgosLoadingButton} from "../../../../components/Buttons/ArgosButton";
import React from "react";

interface IProps {
  isDeleteRwoVersionDialogOpen: any
  setIsDeleteRwoVersionDialogOpen: (rwoId: any) => void
  handleDeleteRwoVersion: (rwoId: string) => void
  isLoadingDeleteRwoVersion: boolean
  warningText: string,
  titleText: string
}

export const DeleteRwoDialog = (props: IProps) => {
  const {
    isDeleteRwoVersionDialogOpen,
    setIsDeleteRwoVersionDialogOpen,
    handleDeleteRwoVersion,
    isLoadingDeleteRwoVersion,
    warningText,
    titleText
  } = props

  return (
    <ArgosDialog
      open={isDeleteRwoVersionDialogOpen !== null}
      width={'auto'} maxWidth={'300px'} height={'auto'}
      headerTitle={titleText} headerTitleAlign={'left'}
    >
      <span>{warningText}</span>
      <ArgosFlexbox justifyContent={'center'} style={{marginTop: 30}}>
        <ArgosButton disabled={isLoadingDeleteRwoVersion} onClick={() => setIsDeleteRwoVersionDialogOpen(null)}>Exit</ArgosButton>
        <ArgosLoadingButton isLoading={isLoadingDeleteRwoVersion} onClick={() => handleDeleteRwoVersion(isDeleteRwoVersionDialogOpen.rwoId)}>Delete</ArgosLoadingButton>
      </ArgosFlexbox>
    </ArgosDialog>
  )
}